import React from 'react';
import { cn } from './utils';
export const Input = React.forwardRef(({ className, ...props }, ref) => <input ref={ref}
  className={cn('pegasus-input sc-flex sc-h-11 sc-w-full sc-rounded-md sc-border sc-border-solid sc-border-border sc-bg-background sc-px-3 sc-py-2 sc-text-sm sc-text-foreground sc-shadow-sm placeholder:sc-text-muted-foreground focus-visible:sc-outline-none focus-visible:sc-ring-2 focus-visible:sc-ring-ring disabled:sc-opacity-50', className)} {...props} />);
Input.displayName = 'Input';
